module.exports = __webpack_public_path__ + "img/community-bg.c2d763f3.svg";